/** Set a session storage item.
 *
 */
export const setStorage = (key, value) => {
    if (!key || !value) {
        return;
    }

    if (typeof value === "object") {
        value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
};

/** Get a session storage item.
 *
 */
export const getStorage = (key) => {
    var value = localStorage.getItem(key);

    if (!value) {
        return;
    }

    // assume it is an object that has been stringified
    if (value[0] === "{") {
        value = JSON.parse(value);
    }

    return value;
};
